import {useEffect} from 'react';
import {API_ASSETS, AVATAR_PATH_ORG} from '../config';

const FAVICON_ID = 'organization-favicon';
const DEFAULT_FAVICON = `${API_ASSETS}logos/fluid.png`;

export default function useOrganizationFavicon(organization) {
	useEffect(() => {
		if (typeof document === 'undefined') {
			return;
		}

		let favicon = document.getElementById(FAVICON_ID);
		const logo = organization?.organization_app_logo_file;

		if (!favicon) {
			favicon = document.createElement('link');
			favicon.id = FAVICON_ID;
			favicon.rel = 'icon';
			document.head.appendChild(favicon);
		}

		favicon.href = logo
			? `${AVATAR_PATH_ORG}${logo}?org=${organization.organization_id}`
			: DEFAULT_FAVICON;

		return () => {
			const currentFavicon = document.getElementById(FAVICON_ID);

			if (currentFavicon) {
				currentFavicon.href = DEFAULT_FAVICON;
			}
		};
	}, [organization?.organization_id, organization?.organization_app_logo_file]);
}
